import {defineStore} from 'pinia';
import {computed} from 'vue';
import {UseMoneyStore} from './moneyStore';
import {UseProductStore} from "@/stores/productStore";
import {useOrderDataStore} from "@/stores/orderDataStore";
import {UseCourierStore} from "@/stores/courierStore";

export const useReturnStore = defineStore('returnStore', () => {
    const moneyStore = UseMoneyStore();
    const courierStore = UseCourierStore();
    const productStore = UseProductStore();
    const orderDataStore = useOrderDataStore();
    
    const totalExtraCost = computed(() => {
        let total = 0;
        let serviceCost = orderDataStore.serviceCost
        if(moneyStore.selectedHowReturnMoney === 'credit'){
            serviceCost = 0
        }
        total += courierStore.selectedCourierReturnCost + serviceCost;
        return total.toFixed(2);
    });

    const totalProductsPrice = computed(() => {
        const total = productStore.selectedProducts.reduce((sum, product) => {
            return sum + Number(product.price.toString().replace('€', ''));
        }, 0);

        return Number(total.toFixed(2));
    });

    const finalReturn = computed(() => {
        return (totalProductsPrice.value - totalExtraCost.value).toFixed(2);
    });



    return {
        totalExtraCost,
        totalProductsPrice,
        finalReturn
    }
},
    {
    persist: true
    }
);
